import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';

@Injectable()
export class LeadService {
    add = (data, callback) => this.globalService.mountResource('POST', { url: '/lead' }, data, callback)

    constructor(protected globalService: GlobalService) { }
}
